import { EditOutlined } from '@ant-design/icons';
import { gql, useMutation } from '@apollo/client';
import { Button, Modal, notification } from 'antd';
import React, { useCallback, useState } from 'react';

export const updateContactMutation = gql`
  mutation ContactChangeSomethingModalA10($contact: ContactUpdateInput!) {
    updateContact(contact: $contact) {
      contact {
        _id
      }
    }
  }
`;

function ContactChangeSomethingModalA10({
  contact,
  children,
  btnProps,
  btnText,
  noBtn,
  editing: editing1,
  onDone: onDone1,
  onCancel: onCancel1,
}) {
  const [editing, setEditing] = useState();
  const handleEdit = useCallback(() => setEditing(true), []);
  const onDone = useCallback(() => setEditing(false), []);
  const onCancel = useCallback(() => setEditing(false), []);

  const [saving, setSaving] = useState(false);
  const [updateContact] = useMutation(updateContactMutation);

  const handleFinish = useCallback(
    async (values) => {
      setSaving(true);
      try {
        await updateContact({
          variables: {
            contact: {
              _id: contact._id,
              ...values,
            },
          },
        });
        notification.success({
          message: 'Success',
          description: 'Contact updated successfully',
        });
        if (noBtn) {
          onDone1();
        } else {
          onDone();
        }
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description: 'There was an error updating your contact',
        });
      }
      setSaving(false);
    },
    [contact, updateContact, onDone, noBtn, onDone1],
  );
  return (
    <>
      <Modal
        open={noBtn ? editing1 : editing}
        closable={false}
        destroyOnClose={true}
        maskClosable
        footer={null}
        onCancel={noBtn ? onCancel1 : onCancel}
        styles={{ body: { paddingTop: 8 } }}
      >
        {React.cloneElement(children, {
          contact,
          thing: contact,
          handleFinish,
          saving,
          setSaving,
          onCancel: noBtn ? onCancel1 : onCancel,
        })}
      </Modal>
      {!noBtn && (
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={handleEdit}
          {...btnProps}
        >
          {btnText}
        </Button>
      )}
    </>
  );
}

export default ContactChangeSomethingModalA10;
